/* eslint-disable */
import requestDev from '@/utils/requestDev'
import { APIReportPHP } from '@/utils/servicesApi'
const qs = require('qs')

export function sentMessagesAnnually(params) {
    return requestDev({
        url: APIReportPHP() + '/zeus/dashboard/sent-messages-annually',
        method: 'POST',
        data: qs.stringify(params)
    })
}


// WEBPACK FOOTER //
// ./src/api/dashboard.js